import { COLLECTION_IDS } from '@/constants/collections';
import { ReferenceType } from '@/interfaces/grpc.interfaces';
import { ISettings } from '@/interfaces/settings.interfaces';

const getDealership = (settings: ISettings, locations?: Array<ReferenceType>) => {
  if (locations) {
    const dealershipLocation = locations.find(
      (location: ReferenceType) =>
        location.collection_id === COLLECTION_IDS.dealersDealership,
    );

    return dealershipLocation;
  }

  return null;
};

export default getDealership;
